import React, { createContext, useState, useEffect } from 'react';
import API from './api';

export const UserContext = createContext();

export function UserProvider({ children }) {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch profile on mount
  useEffect(() => {
    async function fetchProfile() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          setProfile(null);
          setLoading(false);
          return;
        }

        const config = { headers: { Authorization: `Bearer ${token}` } };
        const res = await API.get('/profile/me', config);
        setProfile(res.data || null);
      } catch (error) {
        setProfile(null);
      } finally {
        setLoading(false);
      }
    }
    fetchProfile();
  }, []);

  return (
    <UserContext.Provider value={{ profile, setProfile, loading }}>
      {children}
    </UserContext.Provider>
  );
}
